import styled from 'styled-components';
import RawBreadcrumb from 'react-bootstrap/Breadcrumb';
import Container from 'react-bootstrap/Container';

import theme from '../../theme';

export const Breadcrumb = styled(RawBreadcrumb)`
  > ol {
    background-color: transparent;

    li.breadcrumb-item::before {
      color: #fff;
    }
  }
`;

export const BreadcrumbItem = styled(RawBreadcrumb.Item)``;

/** No cabeçalho compacto, o conteúdo sobe só esta faixa sobre o azul. */
export const COMPACT_HEADER_OVERLAP = 24;

export const Header = styled.header`
  background-color: ${theme.colors.dark_blue};
  min-height: ${({ $compact }) => ($compact ? 0 : 100)}px;
  padding-bottom: ${({ $isOld, $compact }) =>
    $isOld ? 0 : $compact ? COMPACT_HEADER_OVERLAP : 130}px;
`;

export const Main = styled(Container)`
  margin-top: ${({ $isOld, $marginTop }) => ($isOld ? 0 : $marginTop)}px;
  padding-right: 1rem;

  @media (max-width: 768px) {
    padding-right: 0.75rem;
  }

  @media (max-width: 480px) {
    padding-right: 0.5rem;
  }
`;

export const ContentContainer = styled.div`
  padding-left: 60px;
  transition: padding-left 0.3s ease;

  @media (max-width: 768px) {
    padding-left: 42px;
  }

  @media (max-width: 480px) {
    padding-left: 36px;
  }
`;

export const HeaderContentWrapper = styled.div`
  padding-left: 60px;
  transition: padding-left 0.3s ease;

  @media (max-width: 768px) {
    padding-left: 42px;
  }

  @media (max-width: 480px) {
    padding-left: 36px;
  }
`;

export const SaveContainer = styled.div`
  background-color: ${theme.colors.dark_blue};
  padding: 15px;
  z-index: 998;
  position: fixed;
  top: 50px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;

  > button:first-of-type {
    margin-right: 10px;
  }
  > button {
    width: 125px;
  }
`;

export const CenterComponentContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
